const MODULE_NAME = 'fulcrum/container/Project/NvqualSection/EditBox'
const UPDATE_NVQUAL_CURRENT_STATUS = MODULE_NAME + '/UPDATE_NVQUAL_CURRENT_STATUS'
const UPDATE_NVQUAL_CURRENT_COMMENT = MODULE_NAME + '/UPDATE_NVQUAL_CURRENT_COMMENT'
const UPDATE_NVQUAL_CURRENT_REVISION_NAME = MODULE_NAME + '/UPDATE_NVQUAL_CURRENT_REVISION_NAME'
const UPDATE_NVQUAL_CURRENT_EDIT = MODULE_NAME + '/UPDATE_NVQUAL_CURRENT_EDIT'

export {
    MODULE_NAME,
    UPDATE_NVQUAL_CURRENT_STATUS,
    UPDATE_NVQUAL_CURRENT_COMMENT,
    UPDATE_NVQUAL_CURRENT_EDIT,
    UPDATE_NVQUAL_CURRENT_REVISION_NAME
}
